import { render, staticRenderFns } from "./NormalList.vue?vue&type=template&id=5b3d7774&scoped=true&"
import script from "./NormalList.vue?vue&type=script&lang=js&"
export * from "./NormalList.vue?vue&type=script&lang=js&"
import style0 from "./NormalList.vue?vue&type=style&index=0&id=5b3d7774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3d7774",
  null
  
)

export default component.exports